/**
 * Lower price
 *
 * "Lagere prijs gevonden? Klik hier" below the add-to-cart button opens a
 * modal asking for an e-mail address and the link to the lower price. The
 * size, onderkleed and maatwerk measurements chosen in the add-to-cart form
 * are sent along, so the shop sees what the customer compared.
 *
 * See Custom_Theme\Custom\LagerePrijs for the markup and the endpoint.
 */

import $ from 'jquery';

$(function () {
    const $modal = $('#lower-price-modal');

    if (!$modal.length) {
        return;
    }

    const $form = $modal.find('.lower-price-modal__form');
    const $message = $modal.find('.lower-price-modal__error');
    const $submit = $modal.find('.lower-price-modal__action--primary');
    const $success = $modal.find('.lower-price-modal__success');
    let productId = '';

    // What is chosen in the add-to-cart form right now. Read when the modal
    // opens and again on submit, since the form stays usable behind it.
    function selection() {
        const $cart = $('form.cart').first();
        const data = { attributes: {} };

        $cart.find('select[name^="attribute_"]').each(function () {
            if (this.value) {
                data.attributes[this.name] = this.value;
            }
        });

        data.variation_id = $cart.find('input[name="variation_id"]').val() || '';

        if ($('#custom-select').is(':visible')) {
            data.length = $cart.find('input[name="length"]').val() || '';
            data.width = $cart.find('input[name="width"]').val() || '';
        } else if ($('#custom-round-select').is(':visible')) {
            data.diagonal = $cart.find('input[name="diagonal"]').val() || '';
        }

        return data;
    }

    function showMessage(text) {
        $message.text(text).prop('hidden', !text);
    }

    function open(trigger) {
        productId = $(trigger).data('product-id');

        $form.prop('hidden', false);
        $success.prop('hidden', true);
        showMessage('');

        $modal.prop('hidden', false).attr('aria-hidden', 'false');
        $('body').addClass('lower-price-modal-open');
        $form.find('input[name="email"]').trigger('focus');
    }

    function close() {
        $modal.prop('hidden', true).attr('aria-hidden', 'true');
        $('body').removeClass('lower-price-modal-open');
    }

    $modal.on('click', '[data-lower-price-close]', close);

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' && !$modal.prop('hidden')) {
            close();
        }
    });

    $(document).on('click', '[data-lower-price-open]', function (event) {
        event.preventDefault();
        open(this);
    });

    $(document).on('keydown', '[data-lower-price-open]', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            open(this);
        }
    });

    // The Brevo plugin blocklists addresses it catches on blur; see
    // LagerePrijs::render_modal(). Stop that before it reaches document.body.
    document.addEventListener('blur', function (event) {
        if (event.target && event.target.closest && event.target.closest('#lower-price-modal')) {
            event.stopPropagation();
        }
    }, true);

    $form.on('keydown', 'input', function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            submit();
        }
    });

    $form.on('click', '[data-lower-price-submit]', submit);

    function submit() {
        if ($submit.prop('disabled')) {
            return;
        }

        const email = $.trim($form.find('input[name="email"]').val());
        const url = $.trim($form.find('input[name="url"]').val());

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            showMessage('Vul een geldig e-mailadres in.');
            return;
        }

        if (!url) {
            showMessage('Vul de link naar de lagere prijs in.');
            return;
        }

        showMessage('');
        $submit.prop('disabled', true);

        const payload = $.extend(selection(), {
            product_id: productId,
            email: email,
            url: url,
            website: $form.find('input[name="website"]').val(),
        });

        fetch($modal.data('endpoint'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(function (response) {
                return response.json().catch(function () {
                    return {};
                });
            })
            .then(function (result) {
                if (!result || !result.ok) {
                    showMessage((result && result.message) || 'Er ging iets mis. Probeer het later opnieuw.');
                    return;
                }

                $form.prop('hidden', true).find('input').val('');
                $success.prop('hidden', false);
            })
            .catch(function () {
                showMessage('Er ging iets mis. Probeer het later opnieuw.');
            })
            .finally(function () {
                $submit.prop('disabled', false);
            });
    }
});
